export default import.meta.ROLLDOWN_FILE_URL_sCjOvvWs2tFPVugnccfoZA